import { experienceApiClient } from '@/config/httpClients';
import { MeResponseSchema, type MeResponse } from '../auth.schemas';
import { useGlobalStore } from '@/stores/store';

const me = async (customerId: string) => {
  const {
    authStore: { loginAccessToken },
  } = useGlobalStore.getState();
  const response = await experienceApiClient
    .get<MeResponse>(
      `v1/customer-management/customers/${customerId}?include=services`,
      {
        headers: {
          Authorization: `Bearer ${loginAccessToken}`,
        },
      }
    )
    .json();

  const safeParseResponse = MeResponseSchema.safeParse(response);
  if (!safeParseResponse.success) {
    //TODO: Log error to Sentry
    console.error('Error validating me', safeParseResponse.error);
    //Lie to TS in case of any runtime validation errors
    return response as MeResponse;
  } else {
    return response;
  }
};

export { me };
